export default __webpack_public_path__ + "static/media/nazmul.cd2c652d.png";